/* This file was generated automatically. Do not edit manually. */

export enum CheckInConfigurationType {
    Sex = 'Sex',
    Nationality = 'Nationality',
    BirthDate = 'BirthDate',
    BirthPlace = 'BirthPlace',
    Occupation = 'Occupation',
    Phone = 'Phone',
    PurposeOfStay = 'PurposeOfStay',
    PassportOrIdentityCard = 'PassportOrIdentityCard',
    PassportOrIdentityCardOrDriversLicense = 'PassportOrIdentityCardOrDriversLicense',
    DirectIdentityCard = 'DirectIdentityCard',
    DirectPassport = 'DirectPassport',
    DirectDriversLicense = 'DirectDriversLicense',
    Visa = 'Visa',
    PassportIssuingCountry = 'PassportIssuingCountry',
    PassportIssuingCity = 'PassportIssuingCity',
    PassportIssueDate = 'PassportIssueDate',
    PassportExpirationDate = 'PassportExpirationDate',
    IdentityCardIssuingCountry = 'IdentityCardIssuingCountry',
    IdentityCardIssuingCity = 'IdentityCardIssuingCity',
    IdentityCardIssueDate = 'IdentityCardIssueDate',
    IdentityCardExpirationDate = 'IdentityCardExpirationDate',
    DriversLicenseIssuingCountry = 'DriversLicenseIssuingCountry',
    DriversLicenseIssuingCity = 'DriversLicenseIssuingCity',
    DriversLicenseIssueDate = 'DriversLicenseIssueDate',
    DriversLicenseExpirationDate = 'DriversLicenseExpirationDate',
    VisaIssuingCountry = 'VisaIssuingCountry',
    VisaIssuingCity = 'VisaIssuingCity',
    VisaIssueDate = 'VisaIssueDate',
    VisaExpirationDate = 'VisaExpirationDate',
    AddressLine = 'AddressLine',
    AddressCity = 'AddressCity',
    AddressPostalCode = 'AddressPostalCode',
    AddressCountry = 'AddressCountry',
    AddressCountrySubdivision = 'AddressCountrySubdivision',
    CarRegistrationNumber = 'CarRegistrationNumber',
    DietaryRequirements = 'DietaryRequirements',
    VerificationPhoto = 'VerificationPhoto',
    FirstName = 'FirstName',
    LastName = 'LastName',
    SecondLastName = 'SecondLastName',
    Email = 'Email',
    Signature = 'Signature',
    IdVerification = 'IdVerification',
    IdPhotos = 'IdPhotos',
    RelationshipToReservationOwner = 'RelationshipToReservationOwner',
}
